import { observable, action, makeObservable, computed } from 'mobx';

// 将一些路由设置 系统级的设置等 公共的参数都放在这里
enum Recruitment {
  ie = 'ie_recruitment', // 互娱面试
  netease = 'netease_recruitment', // 集团面试
}
class Common {
  constructor() {
    makeObservable(this);
  }

  @observable source: string | undefined = undefined;

  @computed
  get isGroupInterview() {
    return this.source === Recruitment.netease;
  }

  @action
  async setSource(source: string | undefined) {
    this.source = source;
  }
}

export default Common;
